import React from "react";

interface DefectProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconDefect: React.FC<DefectProps> = ({ className, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 21.714" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.495 21.714q-2.371 0-4.043-1.671Q.781 18.37.781 16t1.671-4.042 4.043-1.672 4.042 1.672T12.209 16t-1.672 4.043-4.042 1.671m15.543-1.143-7.314-7.314a26 26 0 0 0-1.486-1.486 5.14 5.14 0 0 0 1.743-1.829q.657-1.143.657-2.514 0-2.143-1.501-3.642-1.499-1.5-3.642-1.5t-3.644 1.5-1.499 3.643a3.4 3.4 0 0 0 .057.657q-.514.057-1.129.229-.614.171-1.099.4a7 7 0 0 1-.114-1.286q0-3.114 2.157-5.271T10.495 0t5.271 2.158 2.157 5.271q0 1.23-.386 2.328a7.4 7.4 0 0 1-1.071 2.015l7.171 7.2zM4.466 18.829 6.495 16.8l2 2.029.829-.8L7.295 16l2.029-2.029-.8-.8L6.495 15.2l-2.029-2.029-.8.8L5.695 16l-2.029 2.029z"
      fill="#C2282B"
    />
  </svg>
);
export default IconDefect;
